module.exports = __webpack_public_path__ + "img/img-7.5f29a91e.png";